/**
 * Stripe.js loader — a single `loadStripe` promise for the whole app.
 *
 * `loadStripe` injects Stripe.js and must be called once; every `<Elements>`
 * mount reuses this one promise. It is created lazily and only when the Stripe
 * payment provider is active (`isStripe()`), so an aeropay build never loads
 * Stripe.js or needs a publishable key. Returns `null` under aeropay or when the
 * publishable key is absent, so callers can guard before mounting `<Elements>`.
 *
 * Each PaymentIntent/SetupIntent has its own `clientSecret`, so the `<Elements>`
 * provider is mounted per-flow (contract charge, add-card) with that secret —
 * we deliberately do NOT wrap the whole app in a single `<Elements>`.
 */
import { loadStripe } from "@stripe/stripe-js";
import { stripe_publishable_key } from "../constants";
import { isStripe } from "./paymentProvider";

let stripePromise;

export const getStripe = () => {
  if (!isStripe() || !stripe_publishable_key) {
    return null;
  }
  if (!stripePromise) {
    stripePromise = loadStripe(stripe_publishable_key);
  }
  return stripePromise;
};
